import { createContext } from "react";
import type { PersonalBestResult } from "hooks/useGetManyPersonalBestQuery/useGetManyPersonalBestQuery";

const ChartPersonalBestsContext = createContext<PersonalBestResult[] | undefined>(undefined);

export default ChartPersonalBestsContext;
